import React, { Component } from 'react';
import {
    Col, Row
} from 'reactstrap';
import RemoveCard from './deleteCard.js';

class CardsContainer extends Component {

    render() {
        //from props 
        // cardArray, jumperId
        return (
            <div>
                <p><strong>Available cards : </strong></p>
                {this.props.cardArray.map((cardOnFile,idx) => {
                    // var cardNumber = "XXXX-XXXX-XXXX-" + cardOnFile.cardNumLast4;
                    var cardNumber = cardOnFile.cardNumLast4;
                    var cardType = cardOnFile.cardType;
                    return (
                        <Row key={idx} style={{ marginBottom: '5px' }} className="cards-container">
                            <Col xs={{ size: 4 }}>Card Number:  </Col>
                            <Col xs={{ size: 7 }}>{cardNumber} {cardType}</Col>
                            <Col xs={{ size: 1 }}>
                                <RemoveCard 
                                    jumperId={this.props.jumperId} cardId={cardOnFile._id} 
                                />
                            </Col>
                        </Row>
                    );
                })
                }
            </div>

        )
    }
}

export default CardsContainer;